'use client';

import StatsApiClient from 'src/utils/StatsApiClient';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { useRef } from 'react';
import { singletonHook } from 'react-singleton-hook';
import { timeAgo } from 'src/utils/dateTime';
import useInterval from '../useInterval';

const TEN_MINUTES = 10 * 60 * 1000;

const useLiquidationStats = () => {
	const setStore = useDriftStore((s) => s.set);
	const initialDataFetched = useRef<number | undefined>(undefined);

	const getAndSetStats = () => {
		StatsApiClient.fetchLiquidations().then((result) => {
			if (result.success && result.stats) {
				setStore((s) => {
					s.liquidationStats['24h'] = {
						totalCount: Number(result.stats!['24h'].count),
						totalAmount: Number(result.stats!['24h'].amount),
					};
					s.liquidationStats['30d'] = {
						totalCount: Number(result.stats!['30d'].count),
						totalAmount: Number(result.stats!['30d'].amount),
					};
				});
			}
		});

		StatsApiClient.fetchBankruptcies().then((result) => {
			if (result.success && result.stats) {
				setStore((s) => {
					s.bankruptcyStats['24h'] = {
						totalAmount: Number(result.stats!.totalAmount),
						totalCount: Number(result.stats!.totalCount),
						ifPayment: Number(result.stats!.ifPayment),
						socialLoss: Number(result.stats!.socialLoss),
						usersSocialLoss: 0, // Not available in new API
					};
				});
			}
		});

		initialDataFetched.current = Date.now();
	};

	useInterval(() => {
		// fetch if its not fetched yet or its over 10 minutes old
		if (
			!initialDataFetched.current ||
			timeAgo(new Date(initialDataFetched.current)) > TEN_MINUTES
		) {
			getAndSetStats();
		}
	}, 6000);
};

export default singletonHook(undefined, useLiquidationStats);
